// src/directives/tooltip-user.js
export default {
  bind (el) {
    // Case 1: directive is on the tag itself (editor @mention)
    const tooltip = el.querySelector('.user-tooltip')

    if (tooltip) {
      // Ensure hidden by default
      tooltip.style.display = 'none'

      const show = () => { tooltip.style.display = 'block' }
      const hide = () => { tooltip.style.display = 'none' }

      // Store handlers so we can remove them later
      el.__tooltipShow__ = show
      el.__tooltipHide__ = hide

      el.addEventListener('mouseenter', show)
      el.addEventListener('mouseleave', hide)
    }
  },

  inserted (el) {
    // Case 2: directive is on a parent container (v-html comments)
    const mentions = el.querySelectorAll('[data-user-id]')

    mentions.forEach(node => {
      const tooltip = node.querySelector('.user-tooltip')
      if (!tooltip) return

      // Ensure hidden by default
      tooltip.style.display = 'none'

      const show = () => { tooltip.style.display = 'block' }
      const hide = () => { tooltip.style.display = 'none' }

      node.__tooltipShow__ = show
      node.__tooltipHide__ = hide

      node.addEventListener('mouseenter', show)
      node.addEventListener('mouseleave', hide)
    })
  },

  unbind (el) {
    // Clean up handlers on the element itself
    if (el.__tooltipShow__) {
      el.removeEventListener('mouseenter', el.__tooltipShow__)
      el.removeEventListener('mouseleave', el.__tooltipHide__)
      delete el.__tooltipShow__
      delete el.__tooltipHide__
    }

    // Clean up on child mentions
    const mentions = el.querySelectorAll('[data-user-id]')
    mentions.forEach(node => {
      if (node.__tooltipShow__) {
        node.removeEventListener('mouseenter', node.__tooltipShow__)
        node.removeEventListener('mouseleave', node.__tooltipHide__)
        delete node.__tooltipShow__
        delete node.__tooltipHide__
      }
    })
  }
}
